export default "__VITE_ASSET__BvGvATUo__"